export class DimensionItemModel {
  Color: string;
  Style: string;
  Size: string;
  configId: string;
  ItemId: string;
  UserId: number;
  CustAccount: string;
  ProjectId: string;
  Currency: string;
  Idioma: string;

  constructor() {
    this.Color = '';
    this.Style = '';
    this.Size = '';
    this.configId = '';
    this.UserId = 0;
    this.ItemId = '';
    this.CustAccount = '';
    this.ProjectId = '';
    this.Currency = '';
    this.Idioma = '';
  }
}
